import Curriculum from "./curriculum/Curriculum";
import CurriculumSport from "./curriculum/CurriculumSport";

/**
 * 프로모션/이벤트 페이지 레지스트리.
 *
 * URL 규칙은 `/promotion/:name` 하나로 고정한다. App.js 에는 이미 두 개의
 * 라우트(`/promotion/:name`, `/promotion/:name/:sub`)가 등록되어 있으므로,
 * 새 프로모션 페이지를 추가할 때 App.js 를 건드릴 필요 없이 여기에만 등록하면 된다.
 *
 *   key   : URL 의 `:name` (kebab-case)
 *   index : `/promotion/:name` 진입 화면
 *   sub   : `/promotion/:name/:sub` 하위 화면 (없으면 하위 경로는 404)
 *
 * 상세 규칙은 ./PROMOTION_PAGE_GUIDE.md 참고.
 */
export const PROMOTION_PAGES = {
    class: { index: Curriculum, sub: CurriculumSport },
};

/**
 * `:name` 에 해당하는 프로모션 페이지 정의를 반환한다.
 * URL 값으로 프로토타입 속성이 조회되지 않도록 own property 만 확인한다.
 *
 * @param {string} name
 * @returns {{index: Function, sub?: Function}|null}
 */
export const findPromotionPage = (name) =>
    Object.prototype.hasOwnProperty.call(PROMOTION_PAGES, name)
        ? PROMOTION_PAGES[name]
        : null;
